import { __extends } from "tslib";
import { WebXRAbstractMotionController } from "./webXRAbstractMotionController";
import { SceneLoader } from "../../Loading/sceneLoader";
import { Mesh } from "../../Meshes/mesh";
import { Axis, Space } from "../../Maths/math.axis";
import { Color3 } from "../../Maths/math.color";
import { WebXRControllerComponent } from "./webXRControllerComponent";
import { SphereBuilder } from "../../Meshes/Builders/sphereBuilder";
import { StandardMaterial } from "../../Materials/standardMaterial";
import { Logger } from "../../Misc/logger";
/**
 * A profiled motion controller has its profile loaded from an online repository.
 * The class is responsible of loading the model, mapping the keys and enabling model-animations
 */
var WebXRProfiledMotionController = /** @class */ (function (_super) {
    __extends(WebXRProfiledMotionController, _super);
    function WebXRProfiledMotionController(scene, xrInput, _profile, _repositoryUrl) {
        var _this = _super.call(this, scene, _profile.layouts[xrInput.handedness || "none"], xrInput.gamepad, xrInput.handedness) || this;
        _this._repositoryUrl = _repositoryUrl;
        _this._buttonMeshMapping = {};
        _this._touchDots = {};
        _this.profileId = _profile.profileId;
        return _this;
    }
    WebXRProfiledMotionController.prototype.dispose = function () {
        var _this = this;
        _super.prototype.dispose.call(this);
        Object.keys(this._touchDots).forEach(function (visResKey) {
            _this._touchDots[visResKey].dispose();
        });
    };
    WebXRProfiledMotionController.prototype._getFilenameAndPath = function () {
        return {
            filename: this.layout.assetPath,
            path: this._repositoryUrl + "/profiles/" + this.profileId + "/",
        };
    };
    WebXRProfiledMotionController.prototype._getModelLoadingConstraints = function () {
        var glbLoaded = SceneLoader.IsPluginForExtensionAvailable(".glb");
        if (!glbLoaded) {
            Logger.Warn("glTF / glb loaded was not registered, using generic controller instead");
        }
        return glbLoaded;
    };
    WebXRProfiledMotionController.prototype._processLoadedModel = function (_meshes) {
        var _this = this;
        this.getComponentIds().forEach(function (type) {
            var componentInLayout = _this.layout.components[type];
            _this._buttonMeshMapping[type] = {
                mainMesh: _this._getChildByName(_this.rootMesh, componentInLayout.rootNodeName),
                states: {},
            };
            Object.keys(componentInLayout.visualResponses).forEach(function (visualResponseKey) {
                var visResponse = componentInLayout.visualResponses[visualResponseKey];
                if (visResponse.valueNodeProperty === "transform") {
                    _this._buttonMeshMapping[type].states[visualResponseKey] = {
                        valueMesh: _this._getChildByName(_this.rootMesh, visResponse.valueNodeName),
                        minMesh: _this._getChildByName(_this.rootMesh, visResponse.minNodeName),
                        maxMesh: _this._getChildByName(_this.rootMesh, visResponse.maxNodeName),
                    };
                }
                else {
                    // visibility, usually for touchpads
                    var nameOfMesh = componentInLayout.type === WebXRControllerComponent.TOUCHPAD_TYPE && componentInLayout.touchPointNodeName ? componentInLayout.touchPointNodeName : visResponse.valueNodeName;
                    _this._buttonMeshMapping[type].states[visualResponseKey] = {
                        valueMesh: _this._getChildByName(_this.rootMesh, nameOfMesh),
                    };
                    if (componentInLayout.type === WebXRControllerComponent.TOUCHPAD_TYPE && !_this._touchDots[visualResponseKey]) {
                        var dot = SphereBuilder.CreateSphere(visualResponseKey + "dot", {
                            diameter: 0.0015,
                            segments: 8,
                        }, _this.scene);
                        dot.material = new StandardMaterial(visualResponseKey + "mat", _this.scene);
                        dot.material.diffuseColor = Color3.Red();
                        dot.parent = _this._buttonMeshMapping[type].states[visualResponseKey].valueMesh || null;
                        dot.isVisible = false;
                        _this._touchDots[visualResponseKey] = dot;
                    }
                }
            });
        });
    };
    WebXRProfiledMotionController.prototype._setRootMesh = function (meshes) {
        this.rootMesh = new Mesh(this.profileId + "-" + this.handedness, this.scene);
        this.rootMesh.isPickable = false;
        var rootMesh;
        // Find the root node in the loaded glTF scene, and attach it as a child of 'parentMesh'
        for (var i = 0; i < meshes.length; i++) {
            var mesh = meshes[i];
            mesh.isPickable = false;
            if (!mesh.parent) {
                // Handle root node, attach to the new parentMesh
                rootMesh = mesh;
            }
        }
        if (rootMesh) {
            rootMesh.setParent(this.rootMesh);
        }
        if (!this.scene.useRightHandedSystem) {
            this.rootMesh.rotate(Axis.Y, Math.PI, Space.WORLD);
        }
    };
    WebXRProfiledMotionController.prototype._updateModel = function (_xrFrame) {
        var _this = this;
        if (this.disableAnimation) {
            return;
        }
        this.getComponentIds().forEach(function (id) {
            var component = _this.getComponent(id);
            if (!component.hasChanges) {
                return;
            }
            var meshes = _this._buttonMeshMapping[id];
            var componentInLayout = _this.layout.components[id];
            Object.keys(componentInLayout.visualResponses).forEach(function (visualResponseKey) {
                var visResponse = componentInLayout.visualResponses[visualResponseKey];
                var value = component.value;
                if (visResponse.componentProperty === "xAxis") {
                    value = component.axes.x;
                }
                else if (visResponse.componentProperty === "yAxis") {
                    value = component.axes.y;
                }
                if (visResponse.valueNodeProperty === "transform") {
                    _this._lerpTransform(meshes.states[visualResponseKey], value, visResponse.componentProperty !== "button");
                }
                else {
                    // visibility
                    var valueMesh = meshes.states[visualResponseKey].valueMesh;
                    if (valueMesh) {
                        valueMesh.isVisible = component.touched || component.pressed;
                    }
                    if (_this._touchDots[visualResponseKey]) {
                        _this._touchDots[visualResponseKey].isVisible = component.touched || component.pressed;
                    }
                }
            });
        });
    };
    return WebXRProfiledMotionController;
}(WebXRAbstractMotionController));
export { WebXRProfiledMotionController };
//# sourceMappingURL=webXRProfiledMotionController.js.map